import { Box, Modal, ModalProps } from '@mui/material'
import { PropsWithChildren } from 'react'

import { Organism } from '@/core/architecture'

type FullscreenModalProps = PropsWithChildren<
  Omit<ModalProps, 'children'> & {
    enableScroll?: boolean
  }
>

export const FullscreenModal: Organism<FullscreenModalProps> = ({
  enableScroll = true,
  children,
  ...props
}) => {
  if (!props.open) return null

  return (
    <Modal {...props}>
      <Box
        bgcolor="background.default"
        sx={{
          '.BaseLayout': {
            height: '100dvh',
            overflowY: 'auto',
          },
        }}
      >
        {children}
      </Box>
    </Modal>
  )
}
